import { getType } from "typesafe-actions";
import { evalActions, EvalActionType } from "../../actions/entities/eval.actions";
import { RequestState } from "../../constants/request-state";
import { EvalState } from "../../types/state/entities/EvalState";

export const evalInitialState: EvalState = {
    items: [],
    requestState: RequestState.none,
    exportRequestState: RequestState.none,
    totalRecordNumber: 0,
    currentPageNumber: 1,
    pageSize: 50
}

export function evalReducer(state: EvalState = evalInitialState, action: EvalActionType): EvalState {
    switch (action.type) {
        case (getType(evalActions.requestResult)):
            return {
                ...state,
                items: action.payload.result ? state.items.concat(action.payload.result) : state.items,
                requestState: action.payload.requestState,
                totalRecordNumber: action.payload.totalRecordNumber || 0,
            };
        case (getType(evalActions.requestStateChange)):
            return {
                ...state,
                requestState: action.payload.requestState,
            };
        case (getType(evalActions.exportRequestStateChange)):
            return {
                ...state,
                exportRequestState: action.payload.requestState,
            };
        case getType(evalActions.loadNextPage):
            return {
                ...state,
                currentPageNumber: state.currentPageNumber + 1
            };
        case getType(evalActions.reset):
            return { ...evalInitialState };
        default: return state
    }
}